import { HttpErrorResponse } from '@angular/common/http';

import { ApiErrorResponse } from '../models/api-error-response.model';

/** First falcon-api error code of a failed request, e.g. "REGISTRATION_OTP_INVALID"; "" if none. */
export function apiErrorCode(error: unknown): string {
  return (
    ((error as HttpErrorResponse)?.error as ApiErrorResponse | undefined)?.errors?.[0]?.code ?? ''
  );
}
